import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

export class FileHolder {
  public serverResponse: { status: number, response: any };
  public pending: boolean = false;

  constructor(public src: string, public file: File) {
  }
}

@Component({
  selector: 'app-image-uploader',
  templateUrl: './image-uploader.component.html',
  styleUrls: ['./image-uploader.component.scss']
})
export class ImageUploaderComponent implements OnInit {
  @Input() max: number = 100;
  @Input() url: string;
  @Input() preview: boolean = true;
  @Input() maxFileSize: number;
  @Input() withCredentials: boolean = false;
  @Input() partName: string;

  @Output()
  isPending: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  onFileUploadFinish: EventEmitter<File> = new EventEmitter<File>();
  @Output()
  onRemove: EventEmitter<FileHolder> = new EventEmitter<FileHolder>();

  files: FileHolder[] = [];
  showFileTooLargeMessage: boolean = false;
  fileCounter: number = 0;
  isFileOver: boolean = false;
  isInvalidType: boolean = false;

  @Input()
  buttonCaption: string = 'Selecciona una imagen';
  @Input()
  dropBoxMessage: string = 'Arrastra una imagen!';
  @Input()
  fileTooLargeMessage: string;
  @Input()
  invalidTypeMsg: string;
  @Input('extensions')
  supportedExtensions: string[];

  private pendingFilesCounter: number = 0;
  @ViewChild('input')
  private inputElement: ElementRef;

  constructor() {
  }

  ngOnInit() {
    this.fileTooLargeMessage = this.fileTooLargeMessage ? this.fileTooLargeMessage :
                                "Tamaño de la imagen demasiado grande";
    this.supportedExtensions = this.supportedExtensions ? this.supportedExtensions.map((ext) => 'image/' + ext) : ['image/*'];
    this.invalidTypeMsg = this.invalidTypeMsg ? this.invalidTypeMsg : 'Tipo de archivo incorrecto';
  }

  fileChange(files: FileList) {
    const remainingSlots = this.countRemainingSlots();
    const filesToUploadNum = files.length > remainingSlots ? remainingSlots : files.length;

    if (this.url && filesToUploadNum != 0) {
      this.isPending.emit(true);
    }

    if (files.length <= 0) {
      alert('Tipo de archivo incorrecto');
    }

    this.fileCounter += filesToUploadNum;
    this.showFileTooLargeMessage = false;
    this.uploadFiles(files, filesToUploadNum);
  }

  deleteFile(file: FileHolder): void {
    const index = this.files.indexOf(file);
    this.files.splice(index, 1);
    this.fileCounter--;
    this.inputElement.nativeElement.value = '';

    this.onRemove.emit(file);
  }


  fileOver(isOver) {
    this.isFileOver = isOver;
  }

  private uploadFiles(files: FileList, filesToUploadNum: number) {
    for (let i = 0; i < filesToUploadNum; i++) {
      let file = files[i]

      if (this.maxFileSize && file.size > this.maxFileSize) {
        this.showFileTooLargeMessage = true;
        continue;
      }

      const img = document.createElement('img');
      img.src = window.URL.createObjectURL(file);

      const reader = new FileReader();
      reader.addEventListener('load', (event: any) => {

        const fileHolder: FileHolder = new FileHolder(event.target.result, file);

        this.onFileUploadFinish.emit(fileHolder.file);

        this.files.push(fileHolder);

      }, false);


      reader.readAsDataURL(file);
    }
  }


  private countRemainingSlots() {
    return this.max - this.fileCounter;
  }
}



// WEBPACK FOOTER //
// ./src/app/image-uploader/image-uploader/image-uploader.component.ts